import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setTicker } from "../../../store/slices/botSlice";
import { setStrategyTicker } from "../../../store/slices/strategySlice";
import CustomPaper from "../../../_components/CustomPaper";
import PairInfo from "../../../_components/PairInfo";
import { useAppNavigate } from "../../../_hooks/use-app-navigate";
import { EntityType, Ticker } from "../../../_app/types";

interface Props {
  onChange?: (value: string) => void;
  onChangeQuote?: (value: string) => void;
  onChangeTicker?: (value: Ticker) => void;
  fullWidth?: boolean;
  ticker: Ticker;
  entity?: EntityType | "";
}

const CurrencyCard = ({ onChange, fullWidth, ticker, onChangeQuote, entity }: Props) => {
  const theme = useTheme();
  const navigate = useAppNavigate();
  const dispatch = useDispatch();

  const [isPressed, setIsPressed] = useState(false);

  const handleMouseDown = () => setIsPressed(true);

  const handleMouseUp = () => setIsPressed(false);

  const handleBase = () => {
    onChange && onChange(ticker.base);
    onChangeQuote && onChangeQuote(ticker.quote);

    entity === "bot" && dispatch(setTicker(ticker));
    entity === "strategy" && dispatch(setStrategyTicker(ticker));

    if (entity) {
      onChange && navigate.creation(entity);
    }
  };

  return (
    <CustomPaper
      fullWidth={fullWidth}
      color={theme.palette.grey[400]}
      onClick={handleBase}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      elevation={isPressed ? 2 : 4}
      sx={{
        transition: "transform 0.1s ease",
        transform: isPressed ? "scale(0.95)" : "scale(1)",
      }}
    >
      <Stack direction="row" spacing={3} alignItems="center">
        <PairInfo base={ticker.base} quote={ticker.quote} size={40} />

        <Typography
          sx={{ fontWeight: 600 }}
          variant="body2"
          component="div"
          color={"textSecondary"}
        >
          {`${ticker.base} / ${ticker.quote}`}
        </Typography>
      </Stack>
    </CustomPaper>
  );
};

export default CurrencyCard;
